import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchTransportReports } from "../../api/transportReportsApi";

const TransportReportsListPage = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchTransportReports({ limit: 50 })
      .then((body) => {
        if (!cancelled) setReports(body.reports || []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Unable to load transport reports.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="crm-experience__inner crm-home-page">
      <header className="crm-home__header">
        <p className="crm-home__eyebrow">Reports</p>
        <h1 className="crm-home__title">Transport Intelligence Reports</h1>
        <p className="crm-home__subtitle">
          Source-aware mobility reports — not official government ratings or navigation products.
        </p>
      </header>

      {loading ? <p className="muted">Loading reports…</p> : null}
      {error ? <p className="error-text">{error}</p> : null}

      {!loading && !reports.length ? (
        <p className="muted">No transport reports generated yet.</p>
      ) : null}

      <div className="crm-nav-list">
        {reports.map((report) => (
          <Link
            key={report.reportKey}
            to={`/reports/transport/${report.reportKey}`}
            className="crm-nav-item"
          >
            <span>
              <span className="crm-nav-label">{report.title}</span>
              <span className="crm-nav-desc">
                {report.reportType} — {new Date(report.generatedAt).toLocaleString()}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TransportReportsListPage;
